import {Link} from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Sidebar from './sidebar';
import LineChart from './LineChart';
import { useState,useEffect } from 'react';
import api from "../api";
import useStoreSetupCheck from './useStoreSetupCheck';
import BarChart0 from './BarChart0';

function SellerReports(){
    const setupStatus = useStoreSetupCheck();
    const [statsLoading, setstatsLoading] = useState(false);
    const [stats, setStats] = useState({
        units_sold: 0,
        total_sales: 0,
        lifetime_revenue: 0,
    });
    const [filter, setFilter] = useState("week");
    const storedCurrency = localStorage.getItem('baseCurrency');
    
    useEffect(() => {
        fetchStats(filter);
    }, [filter]);

    const fetchStats = async (filterOption) => {
        setstatsLoading(true);
        try {
            const response = await api.get(`/vendor-sales-stats-reports/?filter=${filterOption}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` },
            });
            setStats(response.data);
            setstatsLoading(false);
        } catch (error) {
            //console.error("Error fetching stats:", error);
        }
    };
    return (
        <>                                        
            <Helmet>
                <title>Analytics</title>
                <meta name="description" content={`Analytics`} />
            </Helmet>
            <section className="container mtopcon dashb">
                <div className="row">
                        <div className="col-12 col-lg-2 dash-min mb-3">
                            <div className="nav-left-sidebar sidebar-dark pc">
                                <div className="slimScrollDiv" ><div className="menu-list" >
                                    <nav className="navbar navbar-expand-lg navbar-light nav-l-con">
                                        <a className="d-xl-none d-lg-none" href="#"></a>
                                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                            <span className="navbar-toggler-icon"></span>
                                        </button>
                                        <div className="collapse navbar-collapse" id="navbarNav">
                                            <Sidebar/>
                                        </div>
                                    </nav>
                                </div><div className="slimScrollBar"></div><div className="slimScrollRail"></div></div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-10 dash-max">
                            <div className="row mb-3 ph-header-con">
                                <div className="col-7 pt-2"><h6 className="pageheader-title mb-3">Analytics</h6></div>
                            </div>
                            <div className="row">    
                                <div className="mb-4">
                                <div className="btn-group">
                                        {[
                                        { label: "Today", value: "today" },
                                        { label: "Week", value: "week" },
                                        { label: "Month", value: "month" },
                                        { label: "Year", value: "year" },
                                        { label: "All Orders", value: "inception" }
                                        ].map((f) => (
                                        <button
                                            key={f.value}
                                            className={`btn btn-sm font8 ${filter === f.value ? "btn-dark" : "btn-outline-dark"}`}
                                            onClick={() => setFilter(f.value)}
                                        >
                                            {f.label}
                                        </button>
                                        ))}
                                    </div>
                                </div>
                                <div className='col-lg-3 col-12 mb-3'>
                                    <div className="row g-2">

                                        {/* Total Sales */}
                                        <div className="col-6 col-lg-12 mb-2">
                                            <div className="stat-tile bg-soft-purple">
                                                <div>
                                                <p className="stat-label">Revenue</p>
                                                <h3 className="stat-value">
                                                    {parseFloat(stats.total_sales.toFixed(2)).toLocaleString()}
                                                </h3>
                                                </div>
                                                <div className="stat-meta">
                                                {stats.total_sales_deviation >= '0%' ? (
                                                    <span className="text-success">+{stats.total_sales_deviation}</span>
                                                ) : (
                                                    <span className="text-danger">{stats.total_sales_deviation}</span>
                                                )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Units Sold */}
                                        <div className="col-6 col-lg-12 mb-2">
                                            <div className="stat-tile bg-soft-orange">
                                                <div>
                                                <p className="stat-label">Units Sold</p>
                                                <h3 className="stat-value">{stats.units_sold}</h3>
                                                </div>
                                                <div className="stat-meta">
                                                {stats.units_sold_deviation >= '0%' ? (
                                                    <span className="text-success">+{stats.units_sold_deviation}</span>
                                                ) : (
                                                    <span className="text-danger">{stats.units_sold_deviation}</span>
                                                )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Customers */}
                                        <div className="col-6 col-lg-12 mb-2">
                                            <div className="stat-tile bg-soft-blue">
                                                <div>
                                                <p className="stat-label">All Customers</p>
                                                <h3 className="stat-value">{stats.unique_customers}</h3>
                                                </div>
                                                <div className="stat-meta">
                                                {stats.unique_customers_deviation >= '0%' ? (
                                                    <span className="text-success">+{stats.unique_customers_deviation}</span>
                                                ) : (
                                                    <span className="text-danger">{stats.unique_customers_deviation}</span>
                                                )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Repeat Customers */}
                                        <div className="col-6 col-lg-12 mb-2">
                                            <div className="stat-tile bg-soft-green">
                                                <div>
                                                <p className="stat-label">Repeat Customers</p>
                                                <h3 className="stat-value">{stats.repeat_customers}</h3>
                                                </div>
                                                <div className="stat-meta">
                                                {stats.repeat_customers_deviation >= '0%' ? (
                                                    <span className="text-success">+{stats.repeat_customers_deviation}</span>
                                                ) : (
                                                    <span className="text-danger">{stats.repeat_customers_deviation}</span>
                                                )}
                                                </div>
                                            </div>
                                        </div>

                                        </div>
                                </div>        
                                <div className="col-12 col-lg-5">
                                    <div className="card h460 f8 p-3">
                                        
                                        <p className="mb-0"><b>Online Shop Visits</b></p>

                                        <div className="card-body p-1">
                                            <LineChart
                                                chart_title=""
                                                chart_categories={stats.shop_visits?.categories || []}
                                                chart_data={stats.shop_visits?.data || []}
                                            />
                                        </div>
                                        
                                    </div>
                                </div>    
                                  
                                <div className="col-12 col-lg-4">
                                    <div className="card h460 f8 p-3">
                                        
                                        <p className="mb-0"><b>Products Visits</b></p>

                                        <div className="card-body p-1">
                                             <LineChart
                                                chart_title=""
                                                chart_categories={stats.product_visits?.categories || []}
                                                chart_data={stats.product_visits?.data || []}
                                            />
                                        </div>
                                        
                                    </div>
                                </div>  
                                
                                <div className="col-12 col-lg-4">
                                    <div className="card h460 f8 p-3">
                                        
                                        <p className="mb-0"><b>Revenue Overview</b></p>

                                        <div className="card-body p-1">
                                            <LineChart
                                                chart_title=""
                                                chart_categories={stats.revenue_overview?.categories || []}
                                                chart_data={stats.revenue_overview?.data || []}
                                            />
                                        </div>
                                        
                                    </div>
                                </div>   
                                
                                 
                                <div className="col-12 col-lg-4">
                                    <div className="card ldrborad h460 f8 p-3 oscroll">

                                        {/* Header */}
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                        <p className="m-0"><b>Top Customers</b></p>
                                        <Link to="/seller/customers" className="text-primary small">
                                            See details
                                        </Link>
                                        </div>

                                        {/* List */}
                                        {stats?.top_customers?.map((customer, index) => (
                                        <div
                                            key={index}
                                            className="d-flex align-items-center justify-content-between py-2 px-2 rounded mb-2"
                                            style={{ background: "#f9f9f9" }}
                                        >

                                            {/* Left Section */}
                                            <div className="d-flex align-items-center gap-2">

                                            {/* Rank */}
                                            <div
                                                className="d-flex align-items-center justify-content-center"
                                                style={{
                                                width: "28px",
                                                height: "28px",
                                                borderRadius: "8px",
                                                background: index === 0 ? "#f5f1dc" : "#eef1f4",
                                                fontSize: "12px",
                                                fontWeight: "600"
                                                }}
                                            >
                                                {index + 1}
                                            </div>

                                            {/* Avatar */}
                                            <div
                                                style={{
                                                width: "32px",
                                                height: "32px",
                                                borderRadius: "50%",
                                                background: "#ddd",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontSize: "12px",
                                                fontWeight: "600",
                                                color: "#555"
                                                }}
                                            >
                                                {customer.name?.charAt(0)}
                                            </div>

                                            {/* Name */}
                                            <div>
                                                <div className="small fw-semibold">{customer.name}</div>
                                            </div>

                                            </div>

                                            {/* Amount */}
                                            <div className="text-success small fw-semibold">
                                            {storedCurrency} {customer.amount_spent.toLocaleString()}
                                            </div>

                                        </div>
                                        ))}

                                    </div>
                                </div>  
                                <div className="col-12 col-lg-4">
                                    <div className="card pb-4">
                                        <div className="card-header font1 border-0">
                                            <div className='row p-0 m-0'>
                                                <p className='pl-3 m-0 col-11 fbold'>Products Distribution </p>
                                            </div>
                                        </div> 
                                        <div className="card-body p-2">
                                            {stats && stats.top_products && (
                                                <BarChart0
                                                    chart_title=""
                                                    chart_categories={stats.top_products.categories}
                                                    chart_data={stats.top_products.data}
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div className="card h460 f8 p-3">                                        
                                        <p className="mb-3"><b>Revenue by Source</b></p>
                                        {stats?.revenue_by_location?.map((location, index) => {
                                        const maxValue = Math.max(
                                            ...stats.revenue_by_location.map(l => l.revenue)
                                        );
                                        const percentage = (location.revenue / maxValue) * 100;

                                        return (
                                            <div key={index} className="mb-3">
                                            
                                            {/* Top Row */}
                                            <div className="d-flex justify-content-between small mb-1">
                                                <span>{location.location}</span>
                                                <span className="text-muted">
                                                {storedCurrency} {location.revenue.toLocaleString()}
                                                </span>
                                            </div>

                                            {/* Progress Bar */}
                                            <div className="progress" style={{ height: "6px", background: "#eee" }}>
                                                <div
                                                className="progress-bar"
                                                role="progressbar"
                                                style={{
                                                    width: `${percentage}%`,
                                                    backgroundColor: "#8BC34A", // green like image
                                                }}
                                                />
                                            </div>

                                            </div>
                                        );
                                        })}                                        
                                    </div>
                                </div>                     
                            </div>
                        </div>
                </div>
            </section>
        </>
    )
}

export default SellerReports;